import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useProductContent from '~/composables/useProductContent/useProductContent';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
export default defineComponent({
  name: 'BlockBlockListIdentityCard',
  components: {
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    title: String,
    contents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isContentExpanded: {
      type: Boolean,
      default: false
    },
    isPageAdvice: Boolean,
    isInsideBlockList: Boolean
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var components = computed(function () {
      return mapComponentName(props.contents, {
        isContentExpanded: props.isContentExpanded,
        isPageAdvice: props.isPageAdvice,
        isInsideBlockList: props.isInsideBlockList
      });
    });
    provide('hasCarousel', false);
    return {
      components: components,
      classes: classes
    };
  }
});